import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import Select from '../Select';
import KeyToProfession from '../../transforms/KeyToProfession';
import {
  DANCER,
  SINGER,
  MUSICIAN,
  REGISSEUR,
  COSTUME,
  LIGHTING,
  COMPOSER,
  CONDUCTOR,
  MAKEUP,
  STAGE_DESIGNER,
  CHOREOGRAPHER,
  MANAGER,
  MULTIMEDIA,
  getSpecialties,
} from '../../constants';

class ProfessionSpecialty extends Component {
  getSpecialtyTitle = (profession) => {
    switch (profession) {
      case SINGER:
        return 'Registro vocal / Vocal record';
      case MUSICIAN:
        return 'Especialidad Técnica';
      case REGISSEUR:
        return '';
      case COSTUME:
        return '';
      case LIGHTING:
        return '';
      case COMPOSER:
        return '';
      case CONDUCTOR:
        return '';
      case MAKEUP:
        return '';
      case STAGE_DESIGNER:
        return '';
      case CHOREOGRAPHER:
        return '';
      case MANAGER:
        return '';
      case MULTIMEDIA:
        return '';
      default:
        return 'Especialidad';
    }
  };

  hasSpecialty = (profession) => {
    switch (profession) {
      case SINGER:
        return true;
      case MUSICIAN:
        return true;
      case REGISSEUR:
        return false;
      case COSTUME:
        return false;
      case LIGHTING:
        return false;
      case COMPOSER:
        return false;
      case CONDUCTOR:
        return false;
      case MAKEUP:
        return false;
      case STAGE_DESIGNER:
        return false;
      case CHOREOGRAPHER:
        return false;
      case MANAGER:
        return false;
      case MULTIMEDIA:
        return false;
      default:
        return true;
    }
  };

  render() {
    return (
      <Field name={this.props.name}>
        {({ form }) => (
          <Fragment>
            <div className={this.props.boxClassName}>
              <div className="form-group">
                {!this.props.hideLabel && (
                  <label>Profesión</label>
                )}
                <Select
                  name="profession"
                  placeholder="Profesión"
                  onChange={(e) => { form.setFieldValue('profession', e && e.value); }}
                  onBlur={() => form.setFieldTouched('profession', true)}
                  defaultValue={form.values.profession}
                  value={form.values.profession}
                  options={[
                { value: SINGER, label: KeyToProfession(SINGER) },
                { value: DANCER, label: KeyToProfession(DANCER) },
                { value: MUSICIAN, label: KeyToProfession(MUSICIAN) },
                { value: REGISSEUR, label: KeyToProfession(REGISSEUR) },
                { value: COSTUME, label: KeyToProfession(COSTUME) },
                { value: LIGHTING, label: KeyToProfession(LIGHTING) },
                { value: COMPOSER, label: KeyToProfession(COMPOSER) },
                { value: CONDUCTOR, label: KeyToProfession(CONDUCTOR) },
                { value: MAKEUP, label: KeyToProfession(MAKEUP) },
                { value: STAGE_DESIGNER, label: KeyToProfession(STAGE_DESIGNER) },
                { value: CHOREOGRAPHER, label: KeyToProfession(CHOREOGRAPHER) },
                { value: MANAGER, label: KeyToProfession(MANAGER) },
                { value: MULTIMEDIA, label: KeyToProfession(MULTIMEDIA) },
              ]}
                />
                {form.touched.profession && form.errors.profession && (
                  <span className="input-text-error-msg">Debes seleccionar tu profesión</span>
                )}
              </div>
            </div>
            {
              this.hasSpecialty(form.values.profession) && (
                <div className={this.props.boxClassName}>
                  {!this.props.hideLabel && (
                    <label>{this.getSpecialtyTitle(form.values.profession)}</label>
                  )}
                  <Select
                    name="specialty"
                    placeholder="Especialidad"
                    onChange={e => form.setFieldValue('specialty', e && e.value)}
                    onBlur={() => form.setFieldTouched('specialty', true)}
                    defaultValue={form.values.specialty}
                    value={form.values.specialty}
                    options={getSpecialties(form.values.profession)}
                  />
                  {form.touched.specialty && form.errors.specialty && (
                    <span className="input-text-error-msg">Debes seleccionar tu especialidad</span>
                  )}
                </div>
              )
            }
          </Fragment>
          )}
      </Field>
    );
  }
}

ProfessionSpecialty.propTypes = {
  boxClassName: PropTypes.string,
  hideLabel: PropTypes.bool,
};

ProfessionSpecialty.defaultProps = {
  boxClassName: 'col-md-6',
  hideLabel: false,
};

export default ProfessionSpecialty;



// WEBPACK FOOTER //
// ./src/components/ProfessionSpecialty/index.js